<template>
  <svg
    :width="computedWidth"
    :height="computedHeight"
    viewBox="0 0 101 90"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-6.000000, -4.000000)" :fill="color">
        <path
          d="M48.6575633,23.8415456 C57.6039637,35.2082121 73.9456838,27.5778592 69.5811456,16.5119518 C64.98198,4.85116726 78.967415,7.62190972 91.9526106,10.7618723 C89.2942377,19.9546553 85.858706,29.5706512 85.7532113,38.7237279 C85.700641,43.2849067 106.755684,33.1638304 106.714854,52.7779131 C106.674024,72.3919958 85.0079339,60.6498732 84.9469943,64.669916 C84.8329449,72.1934908 86.8323838,80.358412 88.8345752,88.60247 C84.4314132,89.9803581 79.5098161,91.6608153 74.1178434,93.655564 C70.537372,94.9801516 64.957531,94.2733871 68.5947138,80.2179105 C71.0091056,70.8877698 50.0046681,65.8535222 48.6575633,81.9169241 C48.5200571,83.5566021 51.8181085,92.3244688 46.9063271,92.2654619 C41.8772325,92.2050457 32.9190206,89.0931406 24.0038723,86.006768 C26.2133054,77.544851 28.3724343,69.1776488 28.3024742,60.5396673 C28.2718685,56.7607668 6.70124452,67.9456816 6.7149197,49.1220619 C6.72859489,30.2984422 28.319832,41.3592714 28.3024742,37.5501645 C28.2659471,29.5343933 25.6337111,20.8345586 23.1187713,12.3639349 C66.093792,1.4313866 44.2046506,18.1839882 48.6575633,23.8415456 Z"
          transform="translate(56.714913, 51.072550) rotate(-10.000000) translate(-56.714913, -51.072550) "
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      default: 101,
    },
  },
  computed: {
    computedWidth () {
      return this.width + 'px'
    },
    computedHeight () {
      return (this.width * 90 / 101) + 'px'
    },
  },
}
</script>
